import { render, staticRenderFns } from "./FlightFareCards.vue?vue&type=template&id=4bd0f106&scoped=true&"
import script from "./FlightFareCards.vue?vue&type=script&lang=js&"
export * from "./FlightFareCards.vue?vue&type=script&lang=js&"
import style0 from "./FlightFareCards.vue?vue&type=style&index=0&id=4bd0f106&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd0f106",
  null
  
)

export default component.exports